<script lang="ts" setup>
import helpers from '~/helpers'
import type { CategoryData } from '~/types/categories'

const props = defineProps<{
  categoriesData: CategoryData[]
}>()

const getCategories = ref<CategoryData[]>([])

watch(
  () => props.categoriesData,
  (x) => {
    getCategories.value = x
  },
  { immediate: true }
)
</script>

<template>
  <div class="flex w-full flex-col">
    <NuxtLink
      v-for="x in getCategories"
      :key="x.id"
      class="
        mb-0 border-b-[0.5px] border-[#e2e2e2] py-3 !text-sm text-main-dark
        !no-underline transition-colors duration-300 ease-in-out last:border-none
        hover:text-main-green
        md:mb-3 md:border-none md:py-0 md:!text-base
      "
      :to="helpers.getCategoryPath(x)"
    >
      {{ x.attributes.name }}
    </NuxtLink>
  </div>
</template>
